import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class DocumentTypeEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "DocumentType";
        this.primaryEnterpriseComponent = "DocumentType";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "DocumentType";
        eom.enterpriseComponent = "DocumentType";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "DocumentTypeForm2";
        eom.enterpriseComponent = "DocumentTypeForm2";
        eom.relationship = "DocumentTypeDocumentTypeForm2";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default DocumentTypeEnterpriseObjectMetadata;